import React, { memo } from 'react';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import Image from '../Image/Image';
import moment from 'moment';
import SbImage from '../SbImage/SbImage';
import classNames from 'classnames';

export interface VideoThumbnailProps {
  quote: string;
  publisher_name: string;
  publisher_image: StoryblokAsset;
  date_published: Date;
}

export interface VideoThumbnailBlokProps {
  blok: VideoThumbnailProps;
}

const ArticleQuote: React.FC<VideoThumbnailBlokProps> = ({ blok }) => {
  const { quote, publisher_name, publisher_image, date_published } = blok;
  return (
    <div className={'border-l-[4px] border-border/secondary p-8 space-y-10'}>
      <p className="text-text/body font-bold text-xl">"{quote}"</p>
      <div
        className={classNames('flex space-x-4', {
          'items-center': !date_published,
        })}
      >
        {publisher_image?.filename && (
          <div className="w-14 h-14 rounded-full overflow-hidden">
            <SbImage
              asset={publisher_image}
              options={{ sizes: { base: 112 } }}
            />
          </div>
        )}
        <div>
          <p className="text-text/body font-bold text-base">{publisher_name}</p>
          <p className="text-text/body text-base">
            {date_published && moment(date_published).format('MMMM Do YYYY')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default memo(withBlokWrapper(ArticleQuote, Theme.ALT));
